"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyClientDataResponse = void 0;
var ClientData_1 = require("./ClientData");
function makeEmptyClientDataResponse() {
    return {
        exist: false,
        client: ClientData_1.makeEmptyClientData(),
        correctedFormat: '',
    };
}
exports.makeEmptyClientDataResponse = makeEmptyClientDataResponse;
//# sourceMappingURL=ClientDataResponse.js.map